import { useKeyPress } from 'ahooks'
import { useRef } from 'react'

interface IUsePointTooltipKeyboardParams {
  goNext: (e?: KeyboardEvent) => void
  goPrev: (e?: KeyboardEvent) => void
  onClose?: () => void
}

export const usePointTooltipKeyboard = ({
  goNext,
  goPrev,
  onClose,
}: IUsePointTooltipKeyboardParams) => {
  const rootRef = useRef<HTMLDivElement>(null)

  useKeyPress(
    'rightarrow',
    (e) => {
      e.preventDefault()
      goNext(e)
    },
    { target: rootRef },
  )

  useKeyPress(
    'leftarrow',
    (e) => {
      e.preventDefault()
      goPrev(e)
    },
    { target: rootRef },
  )

  useKeyPress(
    'esc',
    (e) => {
      e.stopPropagation()
      e.preventDefault()
      onClose?.()
    },
    { target: rootRef },
  )

  return { rootRef }
}
